<template>
    <div style="display:none">
        <form ref="form" :action="URL" method="get" id="form" target="if">
        </form>
    <iframe ref="iframe" name="if" src="">

    </iframe>
    </div>
</template>

<script>
export default {
  props: ["URL"],
  methods: {
    export(searchData) {
      let str = "";
      for (let i in searchData) {
        str += `<input type="hidden" name="${i}" value="${searchData[i]}" />`;
      }
      this.$refs["form"].innerHTML = str;
      this.$refs["form"].submit();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/exportFile.vue